import React from 'react';
import { Check, ArrowRight, Presentation, Clock, Users, Lightbulb, Mic, MessageCircle, BarChart2, Zap } from 'lucide-react';
import { PageTransition } from '../components/layout/PageTransition';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { DecorativeShape } from '../components/DecorativeShape';
import { Animate } from '../components/ui/Animate';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
export function Talks() {
  const {
    t,
    language
  } = useLanguage();
  const isIS = language === 'is';
  const talks = [{
    id: 'short',
    icon: <Lightbulb size={32} data-id="element-1882" data-mp="3d6hq4umxyxpt" />,
    color: 'bg-coral',
    lightColor: 'bg-coral/10',
    textColor: 'text-coral',
    borderColor: 'border-coral/20',
    tKey: 'short'
  }, {
    id: 'standard',
    icon: <Presentation size={32} data-id="element-1883" data-mp="sfr0me94wrfx" />,
    color: 'bg-teal',
    lightColor: 'bg-teal/10',
    textColor: 'text-teal',
    borderColor: 'border-teal/20',
    tKey: 'standard'
  }, {
    id: 'deep-dive',
    icon: <MessageCircle size={32} data-id="element-1884" data-mp="2mzi3um8uquez" />,
    color: 'bg-blue-600',
    lightColor: 'bg-blue-50',
    textColor: 'text-blue-600',
    borderColor: 'border-blue-200',
    tKey: 'deepDive'
  }];
  // Updated topic list - matched to actual writing and content areas
  const topics = [{
    icon: <Users size={24} data-id="element-1885" data-mp="28zqsyudmtu57" />,
    title: isIS ? 'Leiðtogi og stjórnandi' : 'Leadership & management',
    description: isIS ? 'Hvað rannsóknirnar segja um hvað gerir leiðtoga áhrifaríka - og hvað við höldum ranglega' : 'What the research says about what makes leaders effective - and what we wrongly assume does'
  }, {
    icon: <MessageCircle size={24} data-id="element-1886" data-mp="1u7yfyp1b8s6n" />,
    title: isIS ? 'Endurgjöf og þróun' : 'Feedback & development',
    description: isIS ? 'Hvers vegna hefðbundið endurgjöfarlikan virkar gegn námi - og hvað virkar í staðinn' : 'Why the standard feedback model works against learning - and what actually helps people develop'
  }, {
    icon: <BarChart2 size={24} data-id="element-1887" data-mp="1fo5j2otuprv1" />,
    title: isIS ? 'Stefna og val' : 'Strategy & choices',
    description: isIS ? 'Hvað stefna er í raun, hvers vegna þe flest fyrirtæki hafa ekki eina, og hvernig gott óðal líður' : "What strategy actually is, why most organisations don't have one, and what good strategic logic looks like"
  }, {
    icon: <Zap size={24} data-id="element-1888" data-mp="1ydc2yf6dspif" />,
    title: isIS ? 'Hröðun og flóknar aðstæður' : 'Agility & complexity',
    description: isIS ? 'Hvað Agile-hreyfingin lærði um hvernig fyrirtæki geta flokkst í flóknum heimi' : 'What the Agile movement actually learned about how organisations can navigate a complex environment'
  }, {
    icon: <Users size={24} data-id="element-1889" data-mp="2da2u615wiuwy" />,
    title: isIS ? 'Hvernig teymi þróast' : 'How teams develop',
    description: isIS ? 'Tuckman, Wheelan og aðrar rannsóknir - hvernig hópar verða teymi, eða gera það ekki' : 'Tuckman, Wheelan and other research on how groups become teams - or consistently fail to'
  }, {
    icon: <MessageCircle size={24} data-id="element-1890" data-mp="2ncyo1tb4u1ei" />,
    title: isIS ? 'Ágreiningar og krefjandi samtöl' : 'Conflict & difficult conversations',
    description: isIS ? 'Ágreiningur er ekki vandinn - forðunin er vandinn. Hvað rannsóknir sægja um hvernig á að taka á erfiðum samtölum' : "Conflict isn't the problem - avoidance is. What the research shows about how to approach difficult conversations"
  }];
  return <PageTransition data-id="element-1891" data-mp="2ifyidji730nx">
      <div className="pt-12 pb-24" data-id="element-1892" data-mp="2ighn1yiu3sk0">
        <section className="text-center max-w-4xl mx-auto px-4 mb-20 relative" data-id="element-1893" data-mp="2idbzinpusyqe">
          <DecorativeShape type="square" color="bg-teal/10" className="top-0 right-0 w-32 h-32 rotate-12 -z-10" data-id="element-1894" data-mp="2dfai0782t7h1" />
          <DecorativeShape type="circle" color="bg-coral/10" className="bottom-0 left-0 w-40 h-40 -z-10" data-id="element-1895" data-mp="3owjwsgg9fbc0" />
          <Animate data-id="element-1896" data-mp="1ygregfxk8wlf">
            <span className="inline-block px-4 py-2 bg-teal/10 text-teal font-medium rounded-full text-sm mb-6" data-id="element-1897" data-mp="23dhwh8sxe29h">
              {t('talks.badge')}
            </span>
            <h1 className="text-5xl md:text-6xl font-bold mb-6" data-id="element-1898" data-mp="28bjerrij1xjw">
              {t('talks.title')} <br data-id="element-1899" data-mp="2cfzjvqkbh0y2" />
              <span className="text-teal" data-id="element-1900" data-mp="2ccbpyqaymcit">{t('talks.titleHighlight')}</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-1901" data-mp="2hd96yzk8h0iq">
              {t('talks.subtitle')}
            </p>
          </Animate>
        </section>

        {/* Formats */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-24" data-id="element-1902" data-mp="2r4ndvseil2lw">
          <Animate className="text-center mb-12" data-id="element-1903" data-mp="2w2ou85kk2nto">
            <h2 className="text-3xl font-bold text-charcoal mb-4" data-id="element-1904" data-mp="2w4i55x27bu7h">
              {t('talks.chooseTitle')}
            </h2>
            <p className="text-gray-500 max-w-xl mx-auto" data-id="element-1905" data-mp="352u0udhxdi6s">
              {t('talks.chooseSubtitle')}
            </p>
          </Animate>
          <div className="space-y-8" data-id="element-1906" data-mp="tgtbfga9d1y2">
            {talks.map((talk, index) => {
            const topics_list = t(`talks.items.${talk.tKey}.topics`) as string[];
            const format = t(`talks.items.${talk.tKey}.format`) as string[];
            return <Animate key={talk.id} delay={0} data-id="element-1907" data-mp="fhacne3c72yf" data-mpi={index}>
                  <Card className={`p-0 overflow-hidden border-2 ${talk.borderColor}`} data-id="element-1908" data-mp="1c687ewb370vl">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-0" data-id="element-1909" data-mp="184e9gvsa0az4">
                      <div className={`lg:col-span-4 ${talk.lightColor} p-10 flex flex-col justify-center items-center text-center`} data-id="element-1910" data-mp="13do59lvl6e60">
                        <div className={`w-20 h-20 rounded-full ${talk.color} text-white flex items-center justify-center mb-6 shadow-lg`} data-id="element-1911" data-mp="yd0f12f6m1cu">
                          {talk.icon}
                        </div>
                        <h3 className={`text-2xl font-bold ${talk.textColor} mb-2`} data-id="element-1912" data-mp="2a1240k1paueo">
                          {t(`talks.items.${talk.tKey}.title`)}
                        </h3>
                        <div className="flex items-center gap-2 mb-2" data-id="element-1913" data-mp="215cogrmxou97">
                          <Clock size={18} className={talk.textColor} data-id="element-1914" data-mp="257prh8aaqe2a" />
                          <span className={`font-bold ${talk.textColor}`} data-id="element-1915" data-mp="1r8zx40ev2shm">
                            {t(`talks.items.${talk.tKey}.duration`)}
                          </span>
                        </div>
                        <p className="font-medium text-gray-600" data-id="element-1916" data-mp="1i9crf2f3n0ir">
                          {t(`talks.items.${talk.tKey}.subtitle`)}
                        </p>
                      </div>
                      <div className="lg:col-span-8 p-8 md:p-12 flex flex-col justify-center bg-white" data-id="element-1917" data-mp="3cm2rk1w295yl">
                        <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-1918" data-mp="3goh7ad4fnpln">
                          {t(`talks.items.${talk.tKey}.description`)}
                        </p>
                        <div className="mb-6 p-4 bg-gray-50 rounded-xl" data-id="element-1919" data-mp="10ziqg5pc6xka">
                          <p className="text-sm font-medium text-gray-500 mb-1" data-id="element-1920" data-mp="10xfp4piqhi09">
                            {t('talks.idealFor')}
                          </p>
                          <p className="text-gray-700" data-id="element-1921" data-mp="19z5gjvcm8gy1">
                            {t(`talks.items.${talk.tKey}.idealFor`)}
                          </p>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-1922" data-mp="1jqjkqgfii4xi">
                          <div data-id="element-1923" data-mp="1xq1e793r66d7">
                            <p className="text-sm font-bold text-gray-500 uppercase tracking-wide mb-3" data-id="element-1924" data-mp="1xo841jtxl40g">
                              {t('talks.topicsLabel')}
                            </p>
                            <div className="space-y-2" data-id="element-1925" data-mp="3c9xjpn0am89">
                              {topics_list.map((topic: string, i: number) => <div key={i} className="flex items-center" data-id="element-1926" data-mp="3uk5yzs10i05d" data-mpi={i}>
                                  <div className={`mr-3 p-1 rounded-full ${talk.lightColor} ${talk.textColor}`} data-id="element-1927" data-mp="39llvyroypgxu">
                                    <Check size={12} strokeWidth={3} data-id="element-1928" data-mp="3ifqix00z6883" />
                                  </div>
                                  <span className="text-gray-700" data-id="element-1929" data-mp="3nd0jnbtte6b8">{topic}</span>
                                </div>)}
                            </div>
                          </div>
                          <div data-id="element-1930" data-mp="2up4ls3sie8cv">
                            <p className="text-sm font-bold text-gray-500 uppercase tracking-wide mb-3" data-id="element-1931" data-mp="2zo7j1228zaaa">
                              {t('talks.formatLabel')}
                            </p>
                            <div className="space-y-2" data-id="element-1932" data-mp="exp60cgni7b2">
                              {format.map((item: string, i: number) => <div key={i} className="flex items-start" data-id="element-1933" data-mp="jw0dwhndy7qn" data-mpi={i}>
                                  <div className={`mt-1 mr-3 p-1 rounded-full ${talk.lightColor} ${talk.textColor}`} data-id="element-1934" data-mp="24ekps5lb8j1q">
                                    <Check size={12} strokeWidth={3} data-id="element-1935" data-mp="1up15qwlv2j5a" />
                                  </div>
                                  <span className="text-gray-700 text-sm" data-id="element-1936" data-mp="1pq7uzbxyl68t">
                                    {item}
                                  </span>
                                </div>)}
                            </div>
                          </div>
                        </div>
                        <div className="pt-6 border-t border-gray-100" data-id="element-1937" data-mp="1br837vf5gb8f">
                          <Link to="/contact" data-id="element-1938" data-mp="16rbzzyea0ntx">
                            <Button variant={index === 1 ? 'secondary' : 'primary'} rightIcon={<ArrowRight size={18} data-id="element-1940" data-mp="361tvy2z06zj8" />} data-id="element-1939" data-mp="16sn1frk91jhv">
                              {t('talks.bookTalk')}
                            </Button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </Card>
                </Animate>;
          })}
          </div>
        </section>

        {/* Topics - updated to match actual content */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-24" data-id="element-1941" data-mp="31uwi7v8cki9m">
          <Animate className="text-center mb-12" data-id="element-1942" data-mp="2e3r17cqo7jxq">
            <h2 className="text-3xl font-bold text-charcoal mb-4" data-id="element-1943" data-mp="2e4k0xtr7p96d">
              {t('talks.popularTopics')}
            </h2>
            <p className="text-gray-500 max-w-xl mx-auto" data-id="element-1944" data-mp="293cuby0t2g1a">
              {t('talks.popularTopicsSubtitle')}
            </p>
          </Animate>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1945" data-mp="2j2c2lfhns9nr">
            {topics.map((topic, index) => <Animate key={index} delay={index * 0.08} data-id="element-1946" data-mp="1vby8zkjfe2r2" data-mpi={index}>
                <Card className="p-6 text-center h-full border-2 border-gray-100" data-id="element-1947" data-mp="1qfhkgp8bdmdg">
                  <div className="w-14 h-14 mx-auto mb-4 bg-gray-100 rounded-2xl flex items-center justify-center text-gray-600" data-id="element-1948" data-mp="5wxa55q1fj4h">
                    {topic.icon}
                  </div>
                  <h3 className="font-bold text-charcoal mb-2" data-id="element-1949" data-mp="3s3vl888vqwp0">
                    {topic.title}
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-1950" data-mp="x16x8p5zvpz">{topic.description}</p>
                </Card>
              </Animate>)}
          </div>
        </section>

        <section className="max-w-4xl mx-auto px-4 text-center" data-id="element-1951" data-mp="olc2pxg0757e">
          <Animate data-id="element-1952" data-mp="tlpzukg2guqn">
            <Card className="p-12 bg-gradient-to-br from-teal/5 to-coral/5 border-0" data-id="element-1953" data-mp="tk5dhi3woi3v">
              <div className="w-16 h-16 mx-auto mb-6 bg-teal/10 rounded-full flex items-center justify-center" data-id="element-1954" data-mp="fm74ks8ctdvr">
                <Mic size={32} className="text-teal" data-id="element-1955" data-mp="jq4zsruk64jj" />
              </div>
              <h2 className="text-3xl font-bold mb-4" data-id="element-1956" data-mp="30b4l3mo2snuh">
                {t('talks.customTitle')}
              </h2>
              <p className="text-gray-600 mb-8 max-w-xl mx-auto" data-id="element-1957" data-mp="34fm078jhqcyx">
                {t('talks.customDescription')}
              </p>
              <Link to="/contact" data-id="element-1958" data-mp="15wr0kqfjz36w">
                <Button variant="secondary" rightIcon={<ArrowRight size={18} data-id="element-1960" data-mp="1158yfz1smwkc" />} data-id="element-1959" data-mp="15xiodf2wrwmm">
                  {t('talks.customCta')}
                </Button>
              </Link>
            </Card>
          </Animate>
        </section>
      </div>
    </PageTransition>;
}